import { createApolloFetch } from 'apollo-fetch';
import { API_HOST } from '../commons/constants';

export const apolloFetch = createApolloFetch({
  uri: `${API_HOST}/graphql`,
});
